import { Modal } from "react-bootstrap";
import styled from "styled-components/macro";

export const CampaignReportStyles = styled(Modal)`
  .modal-body {
    padding: 24px;
    height: calc(100vh - 200px);
    overflow: auto;

    /* creator platform section */
    .hide-profile {
      width: fit-content;
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;

      color: var(--Neutral-80);
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.14px;
    }

    .campaign-report-wrapper {
      padding-top: 24px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      gap: 24px;

      .brand-name {
        max-width: 168px;
        width: 100%;

        .logo-text {
          display: flex;
          align-items: center;
          gap: 4px;
          color: var(--Neutral-60);
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          width: max-content;
          letter-spacing: -0.012px;

          svg {
            width: 12px;
            height: 12px;
          }
        }

        .main-text {
          color: var(--Neutral-100);
          font-size: 14px;
          font-weight: 500;
          line-height: 24px;
          letter-spacing: -0.021px;
          width: max-content;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .company-details-wrapper {
      display: flex;
      justify-content: space-between;
      gap: 16px;
      flex-direction: column;
      border-bottom: 1px solid var(--Neutral-8);
      padding-bottom: 16px;

      &:last-child {
        border-bottom: none;
      }

      &:first-child {
        padding-bottom: 16px;
      }

      &.creator-details {
        padding-top: 16px;
      }

      .h4 {
        olor: var(--Neutral-100);
        font-size: 18px;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: -0.03px;
      }

      .brand-name {
        &.ig_handle {
          width: auto;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .logo-text {
          display: flex;
          align-items: center;
          gap: 4px;
          color: var(--Neutral-60);
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: -0.012px;

          svg {
            width: 12px;
            height: 12px;
          }
        }

        .anchor-text {
          text-decoration: underline;
        }

        .main-text {
          color: var(--Neutral-100);
          font-size: 14px;
          font-weight: 500;
          line-height: 24px;
          letter-spacing: -0.021px;
        }
      }
    }
  }

  .modal-footer {
    padding: 16px;
    height: 96px;
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    border-top: 1px solid var(--Neutral-8);

    .button-wrapper {
      display: flex;
      gap: 8px;
      align-items: center;
      width: 100%;
    }

    button {
      width: 100%;

      svg {
        width: 16px;
        height: 16px;
      }
    }

    .warning-text {
      color: var(--Neutral-100);
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      letter-spacing: -0.012px;
    }
  }
`;
